<script setup lang="ts">
interface IProps {
    title?: string;
    hasMore?: boolean;
    noMoreOnDesktop?: boolean;
    compactOnMobile?: boolean;
}
const {
    compactOnMobile,
    title = '',
    hasMore,
    noMoreOnDesktop,
} = defineProps<IProps>();
const more = ref(false);
</script>

<template>
    <div
        class="box"
        :class="{ 'compact-on-mobile': compactOnMobile }"
        @click="more = !more"
    >
        <slot name="pre-header" />
        <div class="box-header">
            <div class="header-title">
                <div class="box-title">
                    {{ title }}
                </div>
            </div>
            <div class="box-custom-element">
                <slot name="custom-element" />
            </div>
        </div>
        <div class="box-body">
            <slot />
            <div
                v-show="more"
                class="more-container"
                :class="{ 'no-more-on-desktop': noMoreOnDesktop }"
            >
                <slot name="more" />
            </div>
        </div>
        <div
            v-if="hasMore"
            class="more"
            :class="{
                'no-more-on-desktop': noMoreOnDesktop,
            }"
        >
            {{ more ? 'کمتر' : 'بیشتر' }}
        </div>
    </div>
</template>

<style scoped lang="scss">
.box {
    width: 100%;
    border-radius: 12px;
    background-color: white;
    position: relative;
    @include shadow();
    @include mobile-only {
        border-bottom: solid 1px usePalette($p-cool-gray, $p-100);
    }
    .box-header {
        display: flex;
        align-items: center;
        padding: 12px 12px 0;
        justify-content: space-between;
        .header-title {
            display: flex;
            .box-title {
                @include tg-m($w7, usePalette($p-blue, $p-600));
            }
        }
        .box-custom-element {
            padding-left: 16px;
        }
    }
    .box-body {
        .more-container {
            &.no-more-on-desktop {
                display: block;
                @include mobile-only {
                    display: none;
                }
            }
        }
    }
    .more {
        display: none;
        position: absolute;
        left: 24px;
        bottom: 8px;
        color: usePalette();
        font-size: 12px;
        @include font-weight(500);
        cursor: pointer;
        &.no-more-on-desktop {
            @include mobile-only {
                display: block;
            }
        }
    }
    &.compact-on-mobile {
        @include mobile-only {
            .box-title {
                font-size: 12px;
                @include font-weight();
                color: usePalette($p-cool-gray, $p-800);
            }
            .box-header {
                padding: 8px 8px 0 0;
                height: 28px;
            }
            .box-body {
                padding: 8px;
            }
        }
    }
}
</style>
